import { Injectable } from "@angular/core";
import * as CryptoJS from 'crypto-js';
import { GlobalVariable } from "../../models/vs-models/globals";
@Injectable({
    providedIn: "root"
})
export class AccessSessionStorage {

    encKey = GlobalVariable.SESSION_ENC_KEY;
    getLoginSessionData(key: string) {
        return this.decryptSessionData(sessionStorage.getItem(key),this.encKey);
    }
    setLoginSessionData(key: string, value: any) { 
        sessionStorage.setItem(key, this.encryptSessionData(JSON.stringify(value),this.encKey));
    }
    removeLoginSessionData(key: string) {
        sessionStorage.removeItem(key);
    }

    removeAllSessions(){
        localStorage.clear();
        sessionStorage.clear();
        window.location.replace(GlobalVariable.BASE_UI_URL);
    }

    encryptSessionData(data,encKey){
        let encString =  CryptoJS.AES.encrypt( data, encKey).toString();
        return encString;
    }

    decryptSessionData(encString,encKey){
        let decValue = CryptoJS.AES.decrypt( encString, encKey);
        return decValue.toString(CryptoJS.enc.Utf8);
    }
    
}